module.exports = __webpack_public_path__ + "static/media/ruins-player-login-bg.f640647f.jpg";